import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import { ListingType } from '../../../interfaces/interfaces';

const getString = (val: string | string[] | null | undefined, key?: string): string => {
    if (Array.isArray(val)) {
        if (process.env.NODE_ENV !== 'production' && val.length > 1) {
            console.warn(`useSubscriptionParams: multiple values for param "${key}", using first.`);
        }
        return val[0] ?? '';
    }
    return val ?? '';
};

/**
 * Custom hook to extract and parse all subscription-related URL parameters
 * Provides a centralized, type-safe way to access URL parameters used in subscription flows
 *
 * @returns Object containing all subscription-related URL parameters
 */
export const useSubscriptionParams = () => {
    const location = useLocation();
    return useMemo(() => {
        const parsedParams = queryString.parse(location.search);

        const listingParam = getString(parsedParams['listing'], 'listing');
        const listing: ListingType = (listingParam === 'AIRFM' || listingParam === 'CNGFW')
            ? listingParam as ListingType
            : 'CNGFW';

        return {
            accountId:              getString(parsedParams['acc-id'], 'acc-id'),
            marketplaceToken:       getString(parsedParams['marketplace-token'], 'marketplace-token'),
            productId:              getString(parsedParams['product-id'], 'product-id'),
            productCode:            getString(parsedParams['product-code'], 'product-code'),
            agreementId:            getString(parsedParams['agreement-id'], 'agreement-id'),
            accountStatus:          getString(parsedParams['link-state'], 'link-state'),
            billingAssociationCode: getString(parsedParams['BillingAssociationCode'], 'BillingAssociationCode'),
            listing,
            allParams: parsedParams,
        };
    }, [location.search]);
};
